import type { CustomNode, CustomNodeData } from '@src/components/custom-nodes/types';

export const getValidGotoStatementPositions = (
  nodesToProcess: CustomNode[],
  nodes: CustomNode[],
  excludeNodeIds: string[] = []
) => {
  // Early exit: if there's 0 or 1 node to process, nothing to place after
  if (nodesToProcess.length <= 1) {
    return [];
  }

  // Collect all branchIds that already contain a 'message:goto' node
  const gotoBranchIds = new Set(
    nodes
      .filter((n) => ((n.data as CustomNodeData)?.nodeType ?? '') === 'message:goto')
      .map((n) => n.branchId)
  );

  // Collect a set of all existing branchIds for sibling calculations below
  // const allBranchIds = new Set(nodes.map((n) => n.branchId));

  // Step 1: base filtering
  // - remove explicitly excluded nodes
  // - remove nodes on the root branch (branchId === '1')
  // - remove nodes that belong to branches already containing a 'message:goto'
  const filtered = nodesToProcess.filter((node) => {
    if (excludeNodeIds.includes(node.id)) {
      return false;
    }

    // Filter out nodes on the root branch (branchId === '1')
    if (node.branchId === '1') {
      return false;
    }

    if (gotoBranchIds.has(node.branchId)) {
      return false;
    }

    return true;
  });

  // Step 2: for each branchId, keep only the last node by vertical position (largest position.y)
  // const byBranchLatest = new Map<string, CustomNode>();
  // filtered.forEach((node) => {
  //   const existing = byBranchLatest.get(node.branchId);
  //   if (!existing || node.position.y > existing.position.y) {
  //     byBranchLatest.set(node.branchId, node);
  //   }
  // });

  // const result = Array.from(byBranchLatest.values());

  // Step 3: sibling-aware filtering
  // Keep the candidate only if there are multiple siblings in the same level (same depth)
  // after excluding branches that already have 'message:goto'. This ensures we don't allow
  // adding goto where it would be the only child at that level.
  // const filteredResult = result.filter((node) => {
  //   const numberOfChunks = node.branchId.split('-').length;
  //   const parentId = node.parentBranchId ?? node.branchId.split('-').slice(0, -1).join('-');
  //   const siblings = Array.from(allBranchIds).filter((bid) => bid.startsWith(parentId));
  //   const siblingsWithSameNumberOfChunks = siblings.filter((bid) => bid.split('-').length === numberOfChunks);
  //   const siblingsThatHaveGoto = siblingsWithSameNumberOfChunks.filter((bid) => gotoBranchIds.has(bid));

  //   // Only allow if there is more than one sibling at this depth when ignoring branches with goto
  //   if (siblingsWithSameNumberOfChunks.length - siblingsThatHaveGoto.length > 1) {
  //     return true;
  //   }
  //   return false;
  // });

  return filtered;
};
